<template>
    <div class="facilities">

        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h5>База знаний</h5>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <div class="slider-navigations d-flex" v-if="facilitiesComputed.length">
                        <div id="facilities-prev" class="swiper-button-prev" slot="button-prev">
                            <span class="lnr lnr-arrow-left"></span>
                        </div>
                        <div id="facilities-next" class="swiper-button-next" slot="button-next">
                            <span class="lnr lnr-arrow-right"></span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">

                    <swiper :options="swiperOptions" v-if="facilitiesComputed.length && loaded">

                        <template v-for="(slide, idx) in facilitiesComputed">

                            <swiper-slide class="clearfix" :key="slide.id" v-if="'is_donor' in slide">

                                <div class="facilities__item d-flex">

                                    <donor-slide  :donor="slide" :weight="slide.weight" :index="idx"/>

                                </div>

                            </swiper-slide>

                            <swiper-slide class="clearfix" :key="slide.id" v-else-if="'view_mode' in slide">

                                <div class="facilities__item d-flex">

                                    <homestays-slide   :homestay="slide" :index="idx"/>

                                </div>

                            </swiper-slide>

                            <swiper-slide  class="clearfix" :key="slide.id" v-else>

                                <div class="facilities__item d-flex">

                                    <helps-slide   :facility="slide" :index="idx"/>

                                </div>

                            </swiper-slide>

                        </template>

                    </swiper>

                    <div v-else-if="!loaded">

                        <div class="facilities-wrapper d-flex">
                            <div class="LoaderBalls">
                                <div class="LoaderBalls__item"></div>
                                <div class="LoaderBalls__item"></div>
                                <div class="LoaderBalls__item"></div>
                            </div>
                        </div>


                    </div>

                    <div class="facilities-wrapper d-flex" v-else>
                            Список пуст
                    </div>

                </div>
            </div>

        </div>

    </div>
</template>

<script>

import {Swiper, SwiperSlide} from 'vue-awesome-swiper'

import DonorSlide from "./Donor";
import HomestaysSlide from "./Homestays";
import HelpsSlide from "./Helps";
import Helps from "./Helps";

export default {
    name: "index",
    components:{Helps, Swiper, SwiperSlide, DonorSlide, HomestaysSlide, HelpsSlide },
    data(){

        return {

            swiperOptions: {
                slidesPerView: 2,
                spaceBetween: 20,
                loop: true,
                navigation: {
                    nextEl: '#facilities-next',
                    prevEl: '#facilities-prev',
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                    },
                    768:{
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                },
            },

            donorsPages: 1,
            homestaysPages: 1,
            helpsPages: 1,
            page: 1,

            loaded: false,

            donors: [],
            homestays: [],
            helps: [],

            facilities: [],

            endpoints: {
                donors: '/donors',
                homestays: `/api/homestays`,
                helps: `/api/facilities`,
            },
            arrays: ['donors', 'homestays', 'helps'],

        }

    },

    async mounted() {
        await this.getFacilities()
    },

    watch: {
        facilitiesComputed() {
            this.loaded = false

            setTimeout(() => {
                this.loaded = true
            }, 500)

        },


    },

    computed: {

        facilitiesComputed() {

            let arr = this.facilities

            if ( ! arr.length ) arr = []

            return arr

        },

    },


    methods: {

        async nextStep( _count = 0 ) {

            const [ _D, _HS, _H ]  = this.arrays // ['donors', 'homestays', 'helps']

            if ( this[ _D ].length  +  this[ _H ].length  +  this[ _HS ].length  <  _count ) {

                if ( this[`${ _D }Pages`]  >  this.page  ||  this[`${ _HS }Pages`]  >  this.page  ||  this[`${ _H }Pages`]  >  this.page ) {

                    this.page += 1;

                    await this.getFacilities();

                    return;

                }

            }

            const _prepareArray = [];

            for( const _a  of  this.arrays ){

                if ( this[ _a ].length  &&  _count  >  0 ) {

                    _prepareArray.push( this[ _a ].pop() );

                    _count -= 1;

                }

            }

            this.facilities  =  [ ...this.facilities, ..._prepareArray ];


            if ( +this.facilities.length  %  9  !==  0 ) {

                if ( this[ _D ].length  ||  this[ _H ].length  ||  this[ _HS ].length ) {

                    await this.nextStep( _count );

                }

            }

        },

        async getFacilities() {

            for ( const _a  of  this.arrays ) {

                if (this.page <= this[ `${_a}Pages` ]) {

                    try{

                        const {data} = await this.getDataForArray( _a );

                        if( data.data  &&  data.data.length ){

                            this[ _a ]  =  [ ...data.data.reverse(), ...this[ _a ] ];

                            this[ `${ _a }Pages` ] = data.meta.last_page;

                        }

                    } catch ( _e ){

                        console.log( _e );

                    }

                }

            }

            return await this.nextStep( 9 )

        },

        async getDataForArray( _array ) {

            const params = {
                page: this.page,
                per_page: 9,
            }

            try {

                const  _res  = await axios.get( this.endpoints[ _array ], { params: params } );

                return _res;


            } catch ( _e ) {

                console.log( _e );

            }


        },



    }


}


</script>

<style lang="scss" scoped>


.facilities{

    &-wrapper{
        min-height: 200px;
        align-items: center;
        justify-content: center;
        text-align: center;
        font-size: 35px;
    }

    .slider-navigations{
        justify-content: flex-end;
        margin: -25px -10px 15px;
    }
    .swiper-button-next, .swiper-button-prev {
        position: static;
        background: #EAF1FC;
        border-radius: 20px;
        width: 56px;
        height: 40px;
        outline: none;
        margin: 0 10px;
        font-size: 20px;
        color: #2e76e4;
        transition: background .2s ease, color .2s ease;
        .lnr{
            color: inherit;
        }

        &:hover{
            background: #2e76e4;
            color: #fff;
        }

    }
    .swiper-button-prev:after,
    .swiper-button-next:after{
        display: none;
    }


    padding: 35px 0;


    .swiper-slide{
        height: auto;
        padding: 5px;
    }

    h5{
        font-size: 36px;
        font-weight: bold;
        color: #333333;
        margin-bottom: 0;
    }

    &__item{
        height: 100%;
        box-shadow: 0px 0px 2px rgb(0 0 0 / 10%);
    }

    &::v-deep{


        .card-horizontal{
            display: flex;
            margin-bottom: 0;
            box-shadow: none;
            padding: 20px 24px 16px;
            width: 100%;

            &__user{
                position: relative;
                height: 100%;
                width: 100%;
                padding-bottom: 50px;
            }

            &__user-contact{
                position: absolute;
                padding: 0;
                left: -10px;
                right: -10px;
                bottom: 0;
            }

            &__user-type{
                margin: 0 0 10px;
            }

            &__user-contact-link{
                max-width: 50%;
                flex-grow: 1;
                min-width: min-content;
                margin: 10px 10px 0;
            }
            &__user-right{
                position: static;
            }
            &__user-left{
                margin-right: 12px;
                float: left;
                min-width: unset;
            }

            &__user-photo{
                width: 100px;
                height: 100px;
                margin-bottom: 0;

                span{
                    line-height: 100px;
                    font-size: 30px;
                }

            }


            @media screen and(max-width: 992px) {

                &__user{
                    display: flex;
                    flex-direction: column;
                    padding-bottom: 0;
                }

                &__user-right{
                    display: flex;
                    flex-direction: column;

                }

                &__user-left{
                    float: unset;
                }

                &__user-contact{
                    flex-direction: column;
                    align-items: center;
                    position: static;
                    left: unset;
                    right: unset;
                    margin-top: auto;
                }

                &__user-contact-link{
                    width: auto;
                    max-width: unset;
                    margin: 0 0 10px;
                }

            }



        }


    }


    @media screen and(max-width: 768px){
        &-wrapper{
            font-size: 20px;
        }
        h5{
            font-size: 26px;
            line-height: 30px;
            text-align: center;
        }

        .slider-navigations{
            margin: 15px -10px;
            justify-content: center;
        }

    }

}


.LoaderBalls {
    margin: 0 auto;
    width: 90px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__item {
        $anim-drt: 0.3s;
        $anim-ease: cubic-bezier(.6, .05, .15, .95);
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: #2E76E4;

        &:nth-child(1) {
            animation: bouncing $anim-drt alternate infinite $anim-ease;
        }

        &:nth-child(2) {
            animation: bouncing $anim-drt $anim-drt/4 alternate infinite $anim-ease backwards;
        }

        &:nth-child(3) {
            animation: bouncing $anim-drt $anim-drt/2 alternate infinite $anim-ease backwards;
        }
    }
}


@keyframes bouncing {

    0% {
        transform: translate3d(0, 10px, 0) scale(1.2, 0.85);
    }

    100% {
        transform: translate3d(0, -20px, 0) scale(0.9, 1.1);
    }
}

</style>
